import { Tag } from '@ps/sports-ui-component-library';
import { FeatureFlag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useFeature from '@swf/core/hooks/useFeature';
import { Icon } from '@swf/sports/components';

import { TXTWCL_New_11 } from './BetBuilderTab.messages.json';
import styles from './BetBuilderTab.scss';

interface Props {
  isActive: boolean;
  name: string;
}

const BetBuilderTab: React.FC<Props> = ({ isActive, name }) => {
  const isBetBuilderNewTagEnabled = useFeature(FeatureFlag.ISPBetBuilderNewTag);

  return (
    <>
      {isBetBuilderNewTagEnabled && (
        <Tag className={styles.tag}>
          <Translation {...TXTWCL_New_11} />
        </Tag>
      )}

      <div className={styles.container}>
        <div className={styles.iconContainer}>
          {!isActive && <div className={styles.background} />}
          <Icon name="bet-builder" className={styles.icon} />
        </div>
        {name}
      </div>
    </>
  );
};

export default BetBuilderTab;
